<section class="portfolio-health">
  <div class="portfolio-head">
    <div>
      <h4>Operação de todos os contratos</h4>
      <p>Frota atual e, no período, agendamentos, manutenções, orçamentos e multas — no total e em cada contrato.</p>
    </div>
    <div class="portfolio-filters">
      <label>
        Período
        <select [(ngModel)]="periodDays" (ngModelChange)="load()">
          <option *ngFor="let period of periods" [ngValue]="period.value">{{ period.label }}</option>
        </select>
      </label>
      <label>
        Contrato
        <select [(ngModel)]="contractId" (ngModelChange)="onContractChange()">
          <option [ngValue]="null">Todos os contratos</option>
          <option *ngFor="let row of payload?.contracts" [ngValue]="row.contractId">
            {{ row.contractName }}
          </option>
        </select>
      </label>
      <label>
        Recorte
        <select [(ngModel)]="recorte" (ngModelChange)="renderChart()">
          <option value="todos">Tudo no período</option>
          <option value="pendentes">Pendentes</option>
        </select>
      </label>
    </div>
  </div>

  <div *ngIf="isLoading" class="portfolio-state">Carregando a operação dos contratos...</div>
  <div *ngIf="error && !isLoading" class="portfolio-state portfolio-state--error">
    {{ error }}
    <button type="button" (click)="load()">Tentar novamente</button>
  </div>

  <ng-container *ngIf="!isLoading && !error">
    <div class="kpi-grid">
      <button
        type="button"
        *ngFor="let item of metrics"
        class="kpi-card"
        [class.is-active]="metric === item.key"
        [style.--kpi]="item.color"
        (click)="selectMetric(item.key)">
        <span class="kpi-value">{{ cardValue(item.key) }}</span>
        <span class="kpi-label">{{ item.label }}</span>
        <span class="kpi-hint">{{ cardHint(item.key) }}</span>
      </button>
    </div>

    <div class="charts-row">
      <div class="portfolio-chart card">
        <div class="card-header">
          <h5>Por contrato</h5>
        </div>
        <div class="card-body">
          <div class="chart-box">
            <canvas #compareChart></canvas>
          </div>
        </div>
      </div>
      <div class="portfolio-chart card">
        <div class="card-header">
          <h5>Composição</h5>
        </div>
        <div class="card-body">
          <div class="chart-box chart-box--mix">
            <canvas #mixChart></canvas>
          </div>
        </div>
      </div>
    </div>

    <div class="card portfolio-table-card">
      <div class="card-header">
        <h5>Quebra por contrato</h5>
      </div>
      <div class="table-responsive">
        <table class="table mb-0">
          <thead>
            <tr>
              <th>Contrato</th>
              <th>Frota</th>
              <th>Agendamentos</th>
              <th>Manutenções</th>
              <th>Orçamentos</th>
              <th>Multas</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of rows" (click)="openContract(row)" class="is-clickable">
              <td>
                <strong>{{ row.contractName }}</strong>
                <small>{{ row.contractNumber }}</small>
              </td>
              <td>{{ row.frota }}</td>
              <td>{{ row.agendamentos }}</td>
              <td>{{ rowValue(row, 'manutencoes') }}</td>
              <td>{{ rowValue(row, 'orcamentos') }}</td>
              <td>{{ rowValue(row, 'multas') }}</td>
            </tr>
            <tr *ngIf="rows.length === 0">
              <td colspan="6">Nenhum contrato neste filtro.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <section class="contract-board" *ngFor="let row of rows">
      <header class="contract-board-head">
        <div>
          <h5>{{ row.contractName }}</h5>
          <small>{{ row.contractNumber }}</small>
        </div>
        <button type="button" (click)="openContract(row)">Abrir contrato</button>
      </header>
      <div class="recent-grid">
        <article class="recent-card">
          <div class="recent-card-title">
            <span><i class="fas fa-calendar-alt"></i> Últimos agendamentos</span>
            <a routerLink="/b2b/appointments">Ver agenda</a>
          </div>
          <p *ngIf="row.agendamentosRecentes.length === 0" class="recent-empty">Nenhum agendamento recente.</p>
          <ul *ngIf="row.agendamentosRecentes.length > 0">
            <li *ngFor="let item of row.agendamentosRecentes">
              <div>
                <strong>{{ item.title }}</strong>
                <small>{{ item.subtitle }}</small>
              </div>
              <div class="recent-meta">
                <span>{{ when(item) }}</span>
                <em [class]="tone(item.status)">{{ item.status || '—' }}</em>
              </div>
            </li>
          </ul>
        </article>

        <article class="recent-card">
          <div class="recent-card-title">
            <span><i class="fas fa-file-invoice"></i> Últimos orçamentos</span>
            <a routerLink="/b2b/budget-service-orders">Ver todos</a>
          </div>
          <p *ngIf="row.orcamentosRecentes.length === 0" class="recent-empty">Nenhum orçamento recente.</p>
          <ul *ngIf="row.orcamentosRecentes.length > 0">
            <li *ngFor="let item of row.orcamentosRecentes">
              <div>
                <strong>{{ item.title }}</strong>
                <small>{{ item.subtitle }}<ng-container *ngIf="money(item)"> · {{ money(item) }}</ng-container></small>
              </div>
              <div class="recent-meta">
                <span>{{ when(item) }}</span>
                <em [class]="tone(item.status)">{{ item.status || '—' }}</em>
              </div>
            </li>
          </ul>
        </article>

        <article class="recent-card">
          <div class="recent-card-title">
            <span><i class="fas fa-exclamation-triangle"></i> Últimos sinistros</span>
            <a [routerLink]="['/b2b/contracts', row.contractId, 'sinistros']">Ver todos</a>
          </div>
          <p *ngIf="row.sinistrosRecentes.length === 0" class="recent-empty">Nenhum sinistro recente.</p>
          <ul *ngIf="row.sinistrosRecentes.length > 0">
            <li *ngFor="let item of row.sinistrosRecentes">
              <div>
                <strong>{{ item.title }}</strong>
                <small>{{ item.subtitle }}</small>
              </div>
              <div class="recent-meta">
                <span>{{ when(item) }}</span>
                <em [class]="tone(item.status)">{{ item.status || '—' }}</em>
              </div>
            </li>
          </ul>
        </article>

        <article class="recent-card">
          <div class="recent-card-title">
            <span><i class="fas fa-folder-open"></i> Últimas OS</span>
            <a [routerLink]="['/b2b/contracts', row.contractId, 'manutencoes']">Ver todas</a>
          </div>
          <p *ngIf="row.ordensRecentes.length === 0" class="recent-empty">Nenhuma OS recente.</p>
          <ul *ngIf="row.ordensRecentes.length > 0">
            <li *ngFor="let item of row.ordensRecentes">
              <div>
                <strong>{{ item.title }}</strong>
                <small>{{ item.subtitle }}</small>
              </div>
              <div class="recent-meta">
                <span>{{ when(item) }}</span>
                <em [class]="tone(item.status)">{{ item.status || '—' }}</em>
              </div>
            </li>
          </ul>
        </article>
      </div>
    </section>
  </ng-container>
</section>
